export default "__VITE_ASSET__CRYD4xQo__"